import { MenuItem } from '@mui/material';

import {
  PaginationContainer,
  PaginationControls,
  PaginationText,
  RowsPerPageContainer,
  StyledPagination,
  StyledSelect,
} from './table-styles';

interface TablePaginationProps {
  page: number;
  rowsPerPage: number;
  totalRows: number;
  onPageChange: (_page: number) => void;
  onRowsPerPageChange: (_rowsPerPage: number) => void;
  hideRowsPerPage?: boolean;
  compact?: boolean;
}

export const TablePagination = ({
  page,
  rowsPerPage,
  totalRows,
  onPageChange,
  onRowsPerPageChange,
  hideRowsPerPage = false,
  compact = false,
}: TablePaginationProps): JSX.Element => {
  const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage) || 1);
  const startItem = totalRows === 0 ? 0 : page * rowsPerPage + 1;
  const endItem = Math.min((page + 1) * rowsPerPage, totalRows);

  return (
    <PaginationContainer sx={compact ? { padding: '6px 12px' } : undefined}>
      <PaginationText variant="body2" fontSize={compact ? 11 : undefined}>
        {compact
          ? `Showing ${startItem}-${endItem} of ${totalRows}`
          : `Showing ${startItem}-${endItem} items out of ${totalRows} results found`}
      </PaginationText>

      <PaginationControls>
        {!hideRowsPerPage && (
          <RowsPerPageContainer>
            <PaginationText fontSize={12} variant="body2">
              Rows per page:
            </PaginationText>
            <StyledSelect
              size="small"
              value={rowsPerPage}
              onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
              sx={{ minWidth: 60 }}
            >
              {[5, 10, 25, 50, 100].map((value) => (
                <MenuItem sx={{ fontSize: 12 }} key={value} value={value}>
                  {value}
                </MenuItem>
              ))}
            </StyledSelect>
          </RowsPerPageContainer>
        )}

        <StyledPagination
          page={Math.min(page + 1, totalPages)}
          count={totalPages}
          shape="rounded"
          color="primary"
          size="small"
          onChange={(_, newPage) => onPageChange(newPage - 1)}
          siblingCount={compact ? 0 : 1}
        />
      </PaginationControls>
    </PaginationContainer>
  );
};
